import React from 'react';

import PropTypes from 'prop-types';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { requestPaymentMethods } from 'apps/auth/constants/amplitude/AmplitudeParamValues';

const AddSource = ({ source, isAccount, setIsNewAccount, amplitudePaymentMethodEvent, onClick, iconName = 'plus', variant = 'transparent' }) => {
    const method = isAccount ? requestPaymentMethods.NEW_ACCOUNT : requestPaymentMethods.NEW_CARD;

    const handlePanelClick = () => {
        if (isAccount) {
            setIsNewAccount(true);
        }
        amplitudePaymentMethodEvent(method);
        onClick();
    };

    return (
        source.title && (
            <Panel type="div" onClick={handlePanelClick} isHoverable negativeMargin>
                <DiskBadgeWrapper>
                    <DiskBadge variant={variant} iconName={iconName} />
                </DiskBadgeWrapper>
                <PanelContent>
                    <Text color="primary">{source.title}</Text>
                    <br />
                    <Text size="secondary" color="secondary">
                        {source.sourceList}
                    </Text>
                </PanelContent>
            </Panel>
        )
    );
};
AddSource.propTypes = {
    iconName: PropTypes.string,
    variant: PropTypes.string,
    source: PropTypes.object,
    isAccount: PropTypes.bool,
    setIsNewAccount: PropTypes.func,
    amplitudePaymentMethodEvent: PropTypes.func,
    onClick: PropTypes.func,
};
export default AddSource;
